import * as m from "mithril";
import { MoneyDTO, SeatSelectionDTO } from "../../apiclient/ApiDtos";
import { MessageProvider } from "../../context/AppMessages";
import { formatMoney } from "../../helpers/MoneyFormatter";
import CustomSvgIcon from "../../components/CustomSvgIcon";

interface SelectedSeatComponentAttrs {
  seat: SeatSelectionDTO;
}

export function SelectedSeatComponent(): m.Component<SelectedSeatComponentAttrs> {
  return {
    view(vnode) {
      return m(
        "span.seat-selection-slot.en-only.mr-2",
        vnode.attrs.seat.number == null || vnode.attrs.seat.number.trim() == "" ? " - " : vnode.attrs.seat.number
      );
    }
  };
}
interface OrderedSeatsComponentAttrs {
  allowCollapse?: boolean;
  defaultExpanded?: boolean;
  messageProvider: MessageProvider;
  seatSelections: SeatSelectionDTO[];
  hideTotalTicketPrice?: boolean
}

export function OrderedSeatsComponent(): m.Component<OrderedSeatsComponentAttrs> {
  let isExpanded = false;

  return {
    oninit(vnode) {
      // defaultExpanded is only meaningful when allowCollapse=true
      isExpanded = vnode.attrs.allowCollapse
        ? !!vnode.attrs.defaultExpanded
        : true; // non-collapsible → always expanded
    },

    view(vnode) {
      const { allowCollapse, messageProvider, seatSelections } = vnode.attrs;

      const totalAmount = seatSelections.reduce(
        (acc, seat) => acc + seat.price.amount,
        0
      );

      const totalSeatPrice: MoneyDTO = {
        amount: totalAmount,
        currency: "MMK"
      };

      const isCollapsible = allowCollapse === true;
      const showExpanded = !isCollapsible || (isCollapsible && isExpanded);

      return m("div", {
        onclick: () => (isExpanded = !isExpanded)
      },

        m("div",
          m(".d-flex.justify-content-between",
            m(".text-muted.small", messageProvider.get("seat_numbers")),

            isCollapsible &&
            m("div",
              m(CustomSvgIcon, {
                iconType: isExpanded ? "keyboard_arrow_up" : "keyboard_arrow_down",
                themeCssClass: "svg-info svg-medium"
              })
            )
          ),
          // ---------------------- Expanded View: Seat List with Prices ----------------------
          showExpanded
            ? seatSelections.map(seat =>
              m(".row.my-2",
                m(".col-6",
                  m(SelectedSeatComponent, { seat })
                ),
                m(".col-6.text-right",
                  m("span.text-dark", formatMoney(seat.price))
                )
              )
            )

            // ---------------------- Collapsed View: Tiny Seat Badge Row ----------------------
            : m(".d-flex",
              seatSelections.map(seat =>
                m(SelectedSeatComponent, { seat })
              )
            ),

          // ---------------------- Total Price (Only in Expanded Mode) ----------------------
          //showExpanded &&

          (vnode.attrs.hideTotalTicketPrice == undefined || vnode.attrs.hideTotalTicketPrice == false) && seatSelections.length > 1 &&
          m(".row.mt-3",
            m(".col-6",
              m("span.mr-2 small", messageProvider.get("total_seat_price"))
            ),
            m(".col-6.text-right",
              m("span.text-success.font-weight-bold_",
                seatSelections.length > 0 ? formatMoney(totalSeatPrice) : null
              )
            )
          )
        ),

      );
    }
  };
}
